import { useRef, useState } from "react";

import { IconButton, Tooltip } from "@mui/material";
import { useDropzone } from "react-dropzone";
import { Control, UseFormSetValue, useWatch } from "react-hook-form";
import { IoClose } from "react-icons/io5";
import { RiImageAddFill } from "react-icons/ri";

import { useProfile } from "../../../../../hooks/useProfile";
import {
	ImageViewer,
	TImageViewerRef,
} from "../../../../common/FileViewer/ImageViewer";
import { Loading } from "../../../../common/Loading/Loading";
import { TProfileFieldValues } from "./Profile";

export type TProfileAvatarProps = {
	setValue: UseFormSetValue<TProfileFieldValues>;
	control: Control<TProfileFieldValues>;
};

export function ProfileAvatar(props: TProfileAvatarProps) {
	const [loading, setLoading] = useState(false);
	const imageViewerRef = useRef<TImageViewerRef>(null);
	const { profile, uploadProfilePicture } = useProfile();
	const handleUploadFile = async (files: File[]) => {
		setLoading(true);
		await uploadProfilePicture(files[0]);
		setLoading(false);
	};

	const { avatar } = useWatch({ control: props.control });

	const dropzone = useDropzone({
		noKeyboard: true,
		accept: {
			"image/png": [],
			"image/jpeg": [],
		},
		disabled: loading,
		onDropAccepted: handleUploadFile,
	});

	if (!profile) {
		return null;
	}

	if (avatar) {
		return (
			<div className="avatar-container">
				<img
					src={avatar}
					className="avatar"
					onClick={() => {
						imageViewerRef.current?.open({ url: avatar });
					}}
				/>
				<Tooltip
					title="Remove"
					onClick={() => {
						props.setValue("avatar", "");
					}}>
					<IconButton className="icon-button delete-button">
						<IoClose />
					</IconButton>
				</Tooltip>
				<ImageViewer ref={imageViewerRef} />
			</div>
		);
	}

	return (
		<div
			{...dropzone.getRootProps({ className: "avatar-container no-avatar" })}>
			<input {...dropzone.getInputProps()} disabled={loading} />
			<RiImageAddFill className="icon" />
			{loading && <Loading size={100} circle fixed={false} absolute />}
		</div>
	);
}
